import axiosInstance from "../api/axiosInstance";

export const loginWithUsernameAndPassword = (data: any): Promise<any> => {
  return axiosInstance.post("auth/login", data);
};

export const refreshTokens = (data: any): Promise<any> => {
  return axiosInstance.post("auth/refresh-tokens", data);
};
